import React, { ReactNode, FC } from 'react';
import { Helmet } from 'react-helmet-async';

export interface KitHelmetProps {
  children?: ReactNode;
  titleTemplate?: string;
  locale: string;
  title?: string;
}

const KitHelmet: FC<KitHelmetProps> = ({ children, titleTemplate, locale, title }) => {
  const htmlAttributes = {
    lang: locale,
  };

  return (
    <Helmet htmlAttributes={htmlAttributes} titleTemplate={titleTemplate || 'ChargePoint - %s'}>
      {title && (
        <>
          <title>{title}</title>
          <meta property='og:title' content={title} />
        </>
      )}
      {children}
    </Helmet>
  );
};

export default KitHelmet;
